import {Component, OnInit} from '@angular/core';
import {ActivatedRoute} from '@angular/router';
import {BsModalRef, BsModalService} from 'ngx-bootstrap/modal';
import {UntypedFormBuilder, UntypedFormControl, UntypedFormGroup, Validators} from '@angular/forms';
import {AlertService} from '../../services/alert/alert.service';
import {LoadingService} from '../../services/loading/loading.service';
import {UserService} from '../../services/user/user.service';
import {ColDef, ColGroupDef, GetRowIdFunc, GetRowIdParams, GridApi, GridOptions, RefreshCellsParams} from 'ag-grid-community';
import {Router} from '@angular/router';
import {DocumentManagerService} from '../../services/document-manager/document-manager.service';
import 'ag-grid-enterprise';
import {ButtonRendererComponent2} from '../document-management/btnrender';
import {ButtonRendererDownloadComponent} from '../document-management/btnrenderdownload';
import {ButtonRendererApproveComponent} from '../document-management/btnrenderapprove';
import {ButtonRendererRejectComponent} from '../document-management/btnrenderreject';
import {UploadService} from '../upload/upload.service';
import {DocumentManagerObj} from 'src/app/features/document-management/document';
import AppConstants, {
  file_upload_error,
  file_extension_error,
  BusinessType,
  DocumenetStatuses, system_admin, carrier_user, carrier_user_admin, TypeOfUser
} from 'src/app/shared/common-components/AppConstants';
import {CarrierService} from 'src/app/services/carrier/carrier.service';
import {formatDate} from '@angular/common';
import {ConfirmationModalComponent} from 'src/app/shared/common-components/confirmation-modal/confirmation-modal.component';
import {DownloadService} from 'src/app/services/download/download';
import * as fileSaver from 'file-saver';
import { ButtonRendererFinalizedDocumentComponent } from '../document-management/btnfinalizeddocument';
import { firstValueFrom } from 'rxjs';

@Component({
    selector: 'app-frt-document-management',
    templateUrl: './frt-document-management.component.html',
    styleUrls: ['./frt-document-management.component.css'],
    standalone: false
})

export class FrtDocumentManagementComponent implements OnInit {
  defaultDate = null;
  documentManagementGridOptions: GridOptions = this.initializeDocGridOptions();
  currentUser: any;
  isSysAdmin = false;
  haveRecords = false;
  errorMessage = '';
  status = '';
  private tmssloader;
  gridOptions: GridOptions = this.initializeGridOptions();
  private gridApi!: GridApi<any>;
  private docMgmtGridApi!: GridApi<any>;
  columnAPI: any;
  documentManagementList: any = [];
  documentTypeList: any;
  docObj: any;
  userRole: any;
  disabledExpiryDate: Boolean = false;
  getDataPath;
  documentManagementForm: UntypedFormGroup;
  documentManagementEditForm: UntypedFormGroup;
  frameworkComponents: any;
  public getRowId: GetRowIdFunc = (params: GetRowIdParams) => String(params.data.documentManagerId);
  checkNoEffDate: Boolean = false;
  checkNoExpDate: Boolean = false;
  userEmail: string;
  public detailCellRendererParams: any = {
    refreshStrategy: "everything"
  }
  tspOrOtherDocType: Boolean = false;
  docTypeSelected: Boolean = false;
  private file: File = null;
  messageValue: any = null;
  fileUpload = {status: '', message: ''};
  uploadForm: UntypedFormGroup;
  private maxFileSizeInBytes: number = 1073741824 * 3; // 1.07*10^9 bytes in a gigabyte, times 3 = 3 gigabytes
  uploadTitle: any;
  isCarrierUser: boolean;
  scacCodeList: string[] = [];
  typeaheadlist: string[];
  minLengthToSearch: number;
  maxCharLength: number;
  organizationId: number;
  carrierList: any;
  fileName: string;
  editMode: Boolean = false;
  docIndex: number;
  isAddOpen: boolean;
  isEditOpen: boolean;
  tempList: any;
  businessTypeCheck: string;
  businessTypeChecked: Boolean = false;
  // chooseBusinessType: UntypedFormGroup;
  format = 'MM/dd/yyyy';
  locale = 'en-US';
  editFlag: Boolean = false;
  tspNotificationForm: UntypedFormGroup;
  autoGroupColumnDef = {
    headerName: 'Folders',
    filter: 'agTextColumnFilter',
    width: 600,
    flex: 1,
    wrapText: true,
    cellRendererParams: {
      suppressCount: true,
    },

  };
  icons = {
    groupExpanded:
      '<svg class="usa-icon" aria-hidden="true" focusable="false" role="img" style="color:#e6e600"> <use xlink:href="/assets/uswds/img/sprite.svg#folder_open"></use></svg>',
    // '<i class="font-sans-3xs margin-top-2 display-block" style="color:#e6e600"></i>',
    groupContracted:
      '<svg class="usa-icon" aria-hidden="true" focusable="false" role="img" style="color:#e6e600"><use xlink:href="/assets/uswds/img/sprite.svg#folder"></use></svg>',
    // '<i class="fas fa-folder" style="color:#e6e600"></i>',
  };
  showGrid: boolean;
  scacCode: any;
  modalRef: BsModalRef;
  editRequest: boolean;
  user: any;
  // modalRef: BsModalRef;


  constructor(private fb: UntypedFormBuilder,
              private alertService: AlertService,
              private loader: LoadingService,
              private route: ActivatedRoute,
              private userService: UserService,
              private modalService: BsModalService,
              private documentManagerService: DocumentManagerService,
              private router: Router,
              // private bsModalRef: BsModalRef,
              private uploadService: UploadService,
              private downloadService: DownloadService,
              // private modalService: BsModalService,
              private carrierService: CarrierService
  ) {
    this.user = firstValueFrom(this.userService.getCurrentUserObservable());
    this.tmssloader = this.loader;
    this.frameworkComponents = {
      buttonRenderer: ButtonRendererComponent2,
      buttonRendererApprove: ButtonRendererApproveComponent,
      buttonRendererDownload: ButtonRendererDownloadComponent,
      buttonRendererReject: ButtonRendererRejectComponent,
      buttonRendererFinalizedDocument: ButtonRendererFinalizedDocumentComponent
    };
    this.documentManagementForm = this.fb.group({
      documentType: new UntypedFormControl(null, Validators.required),
      effectiveDate: new UntypedFormControl(new Date(), Validators.required),
      expiryDate: new UntypedFormControl(null, Validators.required),
      additionalComments: new UntypedFormControl(''),
      filePicker: new UntypedFormControl('', Validators.required),
      // sysAdminToggle: new UntypedFormControl(null, Validators.required),
      // sysAdminFinalize: new UntypedFormControl(null, Validators.required),
      scacList: new UntypedFormControl('', this.isSysAdmin ? Validators.required : null)
    });
    this.tspNotificationForm = this.fb.group({
      tspComments: new UntypedFormControl('', Validators.required)
    });
    // this.chooseBusinessType = this.fb.group({
    //   businessType: new UntypedFormControl('', Validators.required),
    // });
    // this.getRowNodeId = (data: any) => {
    //   return data.documentManagerId;
    // };
  }

  onGridReady(params: any) {
    this.gridApi = params.api;
    this.columnAPI = params.columnApi;
    this.gridApi.setGridOption('groupHeaderHeight', 53);
    this.gridApi.setGridOption('headerHeight', 53);
    this.gridApi.setGridOption('rowData', this.documentManagementList);
    this.hideColumnsBasedOnBusinessType();
  }

  onGridReady1(params: any) {
    this.docMgmtGridApi = params.api;
    this.columnAPI = params.columnApi;
    this.docMgmtGridApi.setGridOption('groupHeaderHeight', 53);
    this.docMgmtGridApi.setGridOption('headerHeight', 80);
    this.docMgmtGridApi.setGridOption('rowData', this.documentManagementList);
    this.hideColumnsBasedOnBusinessType();
  }


  hideColumnsBasedOnBusinessType(){
    let visibleKeys = ['finalizedDocument']
    this.columnAPI.api.setColumnsVisible(visibleKeys, true);
  }

  onRowClicked(event: any) {
    if (event.node.data == null || event.node.data.documentStatus != DocumenetStatuses.PENDING_REVIEW) {

    } else {
      this.isAddOpen = true;
      for (let i = 0; i < this.documentManagementList.length; i++) {
        if (event.node.data.documentManagerId == null) {
          const expiryDate = formatDate(this.documentManagementList[i].expiryDate, this.format, this.locale);
          const expDate = new Date(expiryDate);
          const effectiveDate = formatDate(this.documentManagementList[i].effectiveDate, this.format, this.locale);
          const effDate = new Date(effectiveDate);
          this.documentManagementForm.get('expiryDate').setValue(expDate);
          this.documentManagementForm.get('effectiveDate').setValue(effDate);
          this.documentManagementForm.get('documentType').setValue(event.node.data.documentType);
          this.documentManagementForm.get('additionalComments').setValue(event.node.data.additionalComments);
          this.documentManagementForm.get('scacList').setValue(event.node.data.scac);
        }
        if (event.node.data.documentManagerId == this.documentManagementList[i].documentManagerId) {
          this.editFlag = true;
          this.docIndex = i;
          const expiryDate = formatDate(this.documentManagementList[i].expiryDate, this.format, this.locale);
          const expDate = new Date(expiryDate);
          const effectiveDate = formatDate(this.documentManagementList[i].effectiveDate, this.format, this.locale);
          const effDate = new Date(effectiveDate);
          this.documentManagementForm.get('expiryDate').setValue(expDate);
          this.documentManagementForm.get('effectiveDate').setValue(effDate);
          this.documentManagementForm.get('documentType').setValue(this.documentManagementList[i].documentType);
          this.documentManagementForm.get('additionalComments').setValue(this.documentManagementList[i].additionalComments);
          this.documentManagementForm.get('scacList').setValue(this.documentManagementList[i].scac);
          // if(this.documentManagementList[i].adminOnlyFlag == 1) {
          //     this.documentManagementEditForm.get('sysAdminToggle').setValue(true);
          // }
          break;
        }
      }
    }
  }

  ngOnInit(): void {
    this.errorMessage = '';
    if (this.route.snapshot.queryParams['businessTypeBack'] !== undefined &&
      this.route.snapshot.queryParams['businessTypeBack'] !== null) {
      this.businessTypeCheck = this.route.snapshot.queryParams['businessTypeBack'][0];
    } else {
      this.businessTypeCheck = '';
    }
    this.checkUserRole(this.businessTypeCheck);
    this.onBusinessTypeSelect(BusinessType.FRT);
    window.scrollTo(0, 0);
  }

  onBusinessTypeSelect(val) {
    this.businessTypeCheck = val;
    this.checkUserRole(this.businessTypeCheck);
    this.scacSearch();
    this.documentManagementForm.get('additionalComments').setValidators([]);
    this.documentTypeList = ['Certificate of SCAC', 'Certificate of Liability Insurance', 'TSP Agreement (which includes the Trading Partner Information Sheet)',
        'EPA Smartway Certifications', 'Other'];
    this.documentManagementForm.get('additionalComments').updateValueAndValidity();
  }

  scacSearch() {
    this.loader.show();
    this.carrierService.getAllCarrierListByBusinessType(this.businessTypeCheck).subscribe(carierLocalAgentsList => {
      this.loader.hide();
      this.carrierList = carierLocalAgentsList;
      for (const carrierLocalAgentsOutput of carierLocalAgentsList) {
        const scacString = carrierLocalAgentsOutput.scac + ' - ' + carrierLocalAgentsOutput.scacName;
        this.scacCodeList.push(scacString);
      }
      this.minLengthToSearch = 1;
      this.maxCharLength = 1000;
      this.typeaheadlist = this.scacCodeList;
      this.loader.hide();
    }, error => {
      this.loader.hide();
      this.alertService.error('There was an error retrieving the scac list');
    });
  }

  checkUserRole(val) {
    // Get the current user.
    this.loader.show();
    this.currentUser = this.userService.getUserDetails().subscribe(user => {
      this.loader.hide();
      if (val != '') {
        this.businessTypeChecked = true;
      }
      this.currentUser = user;
      this.userEmail = user.email;
      this.organizationId = user.organizationId;
      if (user && user.roles) {
        for (const role of user.roles) {
          if (role.name === carrier_user_admin || role.name === carrier_user) {
            this.isCarrierUser = true;
            break;
          } else if (role.name === system_admin) {
            this.isSysAdmin = true;
          }
        }
      }
      if (this.currentUser.permissions === BusinessType.FRT && this.businessTypeCheck === '') this.businessTypeCheck = BusinessType.FRT;
      if (this.isSysAdmin == true && val != '') {
        this.loader.show();
        this.loadDocumentListForSystemAdmin(val);
      } else if (this.isCarrierUser == true) {
        this.loader.show();
        this.documentManagerService.getDocumentsByCarrierId(this.currentUser.carrierId).subscribe(docList => {
          this.loader.hide();
          this.documentManagementList = docList;
          for (let i = 0; i < this.documentManagementList.length; i++) {
            if (this.documentManagementList[i].effectiveDate == null) {
              this.documentManagementList[i].formattedEffectiveDate = 'Always Effective';
            } else {
              this.documentManagementList[i].formattedEffectiveDate = formatDate(this.documentManagementList[i].effectiveDate, this.format, this.locale);
            }
            if (this.documentManagementList[i].expiryDate == null) {
              this.documentManagementList[i].formattedExpiryDate = 'No Expiration';
            } else {
              this.documentManagementList[i].formattedExpiryDate = formatDate(this.documentManagementList[i].expiryDate, this.format, this.locale);
            }
            this.documentManagementList[i].formattedUploadDate = formatDate(this.documentManagementList[i].dateLastUploaded, this.format, this.locale);
            this.documentManagementList[i].formattedUpdateDate = formatDate(this.documentManagementList[i].updateDate, this.format, this.locale);
            this.documentManagementList[i].currentVersion = 0;
          }
          this.sortDocumentList();
          this.gridApi.setGridOption('rowData', this.documentManagementList);
          this.resetValidatorFordocumentManagementForm();
        });
      }
    });
  }

  resetValidatorFordocumentManagementForm(){
    this.documentManagementForm.get('scacList').clearValidators();
    this.documentManagementForm.get('scacList').updateValueAndValidity();
    /**
     * this.documentManagementForm = this.fb.group({
      documentType: new UntypedFormControl(null, Validators.required),
      effectiveDate: new UntypedFormControl(new Date(), Validators.required),
      expiryDate: new UntypedFormControl(null, Validators.required),
      additionalComments: new UntypedFormControl(''),
      filePicker: new UntypedFormControl('', Validators.required),
      // sysAdminToggle: new UntypedFormControl(null, Validators.required),
      // sysAdminFinalize: new UntypedFormControl(null, Validators.required),
      scacList: new UntypedFormControl('', Validators.required)
    });
     */
  }

  loadDocumentListForSystemAdmin(val: any){
    this.documentManagerService.getDocumentsByBusinessType(val).subscribe(docList => {
      this.loader.hide();
      docList = docList.map(document => {
        document.tspSigned = (document.tspSigned) ? 1 : 0;
        document.gsaSigned = document.gsaSigned ? 1 : 0;
        return document;
      });
      this.documentManagementList = docList;
      for (let i = 0; i < this.documentManagementList.length; i++) {
        if (this.documentManagementList[i].effectiveDate == null) {
          this.documentManagementList[i].formattedEffectiveDate = 'Always Effective';
        } else {
          this.documentManagementList[i].formattedEffectiveDate = formatDate(this.documentManagementList[i].effectiveDate, this.format, this.locale);
        }
        if (this.documentManagementList[i].expiryDate == null) {
          this.documentManagementList[i].formattedExpiryDate = 'No Expiration';
        } else {
          this.documentManagementList[i].formattedExpiryDate = formatDate(this.documentManagementList[i].expiryDate, this.format, this.locale);
        }
        this.documentManagementList[i].formattedUploadDate = formatDate(this.documentManagementList[i].dateLastUploaded, this.format, this.locale);
        this.documentManagementList[i].formattedUpdateDate = formatDate(this.documentManagementList[i].updateDate, this.format, this.locale);
        this.documentManagementList[i].currentVersion = 0;
      }
      this.sortDocumentList();
    });
  }

  groupBy(arr, ...props) {
    return arr.reduce((acc, obj) => {
      const key = props.map(key => obj[key]).join('-');
      acc[key] = acc[key] || [];
      acc[key].push(obj);
      return acc;
    }, {});
  }

  sortDocumentList() {
    this.documentManagementList.sort((a, b) => {
      if (a.scac === b.scac) {
        return a.documentType < b.documentType ? -1 : 1;
      } else {
        return a.scac < b.scac ? -1 : 1;
      }
    });
  }

  checkUserRoleNoVal() {
    // Get the current user.
    this.loader.show();
    this.currentUser = this.userService.getUserDetails().subscribe(user => {
      this.loader.hide();
      this.currentUser = user;
      this.organizationId = user.organizationId;
      if (user && user.roles) {
        for (const role of user.roles) {
          if (role.name === carrier_user_admin || role.name === carrier_user) {
            this.isCarrierUser = true;
            break;
          } else if (role.name === system_admin) {
            this.isSysAdmin = true;
          }
        }
      }
    });
  }

  fInput(e) {
    this.file = e.target.files[0];
    const validFileExtn = this.validateFileExtension();

    if(validFileExtn){
      if (this.file.size > this.maxFileSizeInBytes) {
        this.fileUpload = {status: 'error', message: 'You have selected a file larger than the max file size (3GB)'};
      } else {
        this.fileUpload = {status: 'ok', message: ''};
      }
    }
  }
  validateFileExtension() {
    const f: string[] = this.file.name.split('.');
    let ext = '';
    if (f.length > 1) {
      ext = f[f.length - 1];
      if (ext.toUpperCase() !== 'PDF' && ext.toUpperCase() !== 'PNG' && ext.toUpperCase() !== 'BMP' && ext.toUpperCase() !== 'JPG' && ext.toUpperCase() !== 'JPEG') {
        this.fileUpload = {status: 'error', message: 'Please upload pdf or image (bmp, jpg, jpeg, png) files!'};
        this.documentManagementForm.get('filePicker').setValue('');
        return false;
        //this.documentManagementForm.get('filePicker').setValue('');
      } else {
        this.fileUpload = {status: 'ok', message: ''};
        return true;
      }
    } else {
      this.fileUpload = {status: 'ok', message: ''};
      return true;
    }
  }

  uploadFile() {
    this.validateFileExtension();
    if (AppConstants.isNotNullCondition(this.fileUpload.message) && (this.fileUpload.message === file_upload_error || this.fileUpload.message === file_extension_error)) {
      this.alertService.info(this.fileUpload.message);
      return false;
    }
    if (AppConstants.isNotNullCondition(this.file)) {
      this.checkUserRoleNoVal();
      if (this.isSysAdmin == true) {
        this.uploadService.postDoc(this.file, this.documentManagementForm.get('scacList').value.substr(0, 4)).subscribe(
          result => {
            this.fileUpload = result;
            setTimeout(() => {
              this.file = null;
              this.documentManagementForm.get('filePicker').setValue('');
              this.documentManagementForm.get('filePicker').setValidators([Validators.required]);
            }, 2500);
            return true;
          },
          error => {
            this.fileUpload = {status: 'error', message: error.name + ': ' + error.message};
            return false;
          }
        );
      } else if (this.isCarrierUser == true) {
        this.uploadService.postFile(this.file, 'Documents').subscribe(
          result => {
            this.fileUpload = result;
            setTimeout(() => {
              this.file = null;
              this.documentManagementForm.get('filePicker').setValue('');
              this.documentManagementForm.get('filePicker').setValidators([Validators.required]);
            }, 2500);
            return true;
          },
          error => {
            this.fileUpload = {status: 'error', message: error.name + ': ' + error.message};
            return false;
          }
        );
      }
    } else {
      this.alertService.info('please select a file before upload!');
      return false;
    }
  }

  uploadFileWithDetails() {
    this.validateFileExtension();
    if (AppConstants.isNotNullCondition(this.fileUpload.message) && (this.fileUpload.message === file_upload_error || this.fileUpload.message === file_extension_error)) {
      this.alertService.info(this.fileUpload.message);
      return false;
    }
    if (AppConstants.isNotNullCondition(this.file)) {
      this.checkUserRoleNoVal();
      this.validateFileExtension();
      if (this.isSysAdmin == true) {
        this.uploadService.postDocWithDetails(this.file, this.documentManagementForm.get('scacList').value.substr(0, 4), this.docObj.documentType, this.docObj.fileName).subscribe(
          result => {
            this.fileUpload = result;
            setTimeout(() => {
              this.file = null;
              this.documentManagementForm.get('filePicker').setValue('');
              this.documentManagementForm.get('filePicker').setValidators([Validators.required]);
            }, 2500);
            return true;
          },
          error => {
            this.fileUpload = {status: 'error', message: error.name + ': ' + error.message};
            return false;
          }
        );
      } else if (this.isCarrierUser == true) {
        this.uploadService.postFileWithDetails(this.file, 'Documents', this.docObj.documentType, this.docObj.fileName, this.docObj.organizationId).subscribe(
          result => {
            this.fileUpload = result;
            setTimeout(() => {
              this.file = null;
              this.documentManagementForm.get('filePicker').setValue('');
              this.documentManagementForm.get('filePicker').setValidators([Validators.required]);
            }, 2500);
            return true;
          },
          error => {
            this.fileUpload = {status: 'error', message: error.name + ': ' + error.message};
            return false;
          }
        );
      }
    } else {
      this.alertService.info('please select a file before upload!');
      return false;
    }
  }

  upload() {
    if (this.editFlag == true) {
      this.modalRef = this.modalService.show(ConfirmationModalComponent);
      this.modalRef.content.body = 'Would you like to edit this existing document or create a new one?';
      this.modalRef.content.title = 'Confirm Edit';
      this.modalRef.content.confirmText = 'Edit Document';
      this.modalRef.content.cancelText = 'Upload New Document';
      this.modalRef.content.emitData.subscribe(res => {
        this.editRequest = res;
        this.docObj = new DocumentManagerObj();
        this.docObj.documentType = this.documentManagementForm.get('documentType').value;
        if (res.obj == false) {
          this.docObj.dateCreated = new Date();
          this.docObj.documentStatus = this.docObj.documentType.includes("TSP Agreement") ? DocumenetStatuses.FINALIZED : DocumenetStatuses.PENDING_REVIEW;
        } else {
          this.docObj.documentManagerId = this.documentManagementList[this.docIndex].documentManagerId;
          this.docObj.dateCreated = this.documentManagementList[this.docIndex].dateCreated;
          this.docObj.documentStatus = this.documentManagementList[this.docIndex].documentStatus;
        }
        this.docObj.tspSigned = 0;
        this.docObj.gsaSigned = 0;
        
        if (this.documentManagementForm.get('effectiveDate').touched == false || this.checkNoEffDate === false) {
          this.docObj.effectiveDate = this.documentManagementForm.get('effectiveDate').value;
        } else {
          this.docObj.effectiveDate = (!this.checkNoEffDate) ? this.documentManagementForm.get('effectiveDate').value : null;
        }
        if (this.documentManagementForm.get('expiryDate').touched == false || this.checkNoExpDate === false) {
          this.docObj.expiryDate = this.documentManagementForm.get('expiryDate').value;
        } else {
          this.docObj.expiryDate = (!this.checkNoExpDate) ? this.documentManagementForm.get('expiryDate').value : null;
        }

        if(this.checkNoExpDate === false){
          this.docObj.expiryDate = (!this.checkNoExpDate) ? this.documentManagementForm.get('expiryDate').value : null;
        }else{
          if (this.documentManagementForm.get('expiryDate').touched == false || this.checkNoExpDate === false) {
            this.docObj.expiryDate = this.documentManagementForm.get('expiryDate').value;
          }
        }

        this.docObj.dateLastUploaded = new Date();
        this.docObj.customerType = TypeOfUser.TSP;
        this.docObj.userId = this.currentUser.userId;
        // this.docObj.organizationId = 1;
        this.docObj.organizationId = this.organizationId;
        const fileNaming = this.documentManagementForm.get('filePicker').value;
        this.docObj.fileName = fileNaming.substr(fileNaming.indexOf('C:\\fakepath\\') + 12);
        this.docObj.documentName = this.docObj.fileName;
        this.docObj.additionalComments = this.documentManagementForm.get('additionalComments').value;
        this.docObj.businessType = this.businessTypeCheck;
        if (this.isSysAdmin == true) {
          const scacFull = this.documentManagementForm.get('scacList').value;
          this.scacCode = scacFull.substr(0, scacFull.indexOf(' '));
          if (this.scacCode == '') {
            this.scacCode = scacFull;
          }
          this.docObj.scac = this.scacCode;
          
          for (const carrierItem of this.carrierList) {
            if (this.scacCode == carrierItem.scac) {
              this.docObj.carrierId = carrierItem.carrierId;
              break;
            }
          }
        } else if (this.isCarrierUser == true) {
          this.docObj.carrierId = this.currentUser.carrierId;
        }
        if (res.obj == false) {
          this.documentManagementList.push(this.docObj);
        } else {
          this.documentManagementList[this.docIndex] = this.docObj;
        }
        if (this.uploadFileWithDetails() != false) {
          this.loader.show();
          this.documentManagerService.saveDocument(this.docObj).subscribe(data => {
            this.alertService.success('Saved Document');
            this.loader.hide();
            if (res.obj == false) {
              this.documentManagementList[this.documentManagementList.length - 1].scac = this.scacCode;
              this.documentManagementList[this.documentManagementList.length - 1].documentManagerId = data.documentManagerId;
              if (data.effectiveDate == null) {
                this.documentManagementList[this.documentManagementList.length - 1].formattedEffectiveDate = 'Always Effective';
              } else {
                this.documentManagementList[this.documentManagementList.length - 1].formattedEffectiveDate = formatDate(data.effectiveDate, this.format, this.locale);
              }
              if (data.expiryDate == null) {
                this.documentManagementList[this.documentManagementList.length - 1].formattedExpiryDate = 'No Expiration';
              } else {
                this.documentManagementList[this.documentManagementList.length - 1].formattedExpiryDate = formatDate(data.expiryDate, this.format, this.locale);
              }
              this.documentManagementList[this.documentManagementList.length - 1].formattedUploadDate = formatDate(this.docObj.dateLastUploaded, this.format, this.locale);
            } else {
              this.documentManagementList[this.docIndex].scac = this.scacCode;
              if (data.effectiveDate == null) {
                this.documentManagementList[this.documentManagementList.length - 1].formattedEffectiveDate = 'Always Effective';
              } else {
                this.documentManagementList[this.documentManagementList.length - 1].formattedEffectiveDate = formatDate(data.effectiveDate, this.format, this.locale);
              }
              if (data.expiryDate == null) {
                this.documentManagementList[this.documentManagementList.length - 1].formattedExpiryDate = 'No Expiration';
              } else {
                this.documentManagementList[this.documentManagementList.length - 1].formattedExpiryDate = formatDate(data.expiryDate, this.format, this.locale);
              }
              this.documentManagementList[this.docIndex].formattedUploadDate = formatDate(this.docObj.dateLastUploaded, this.format, this.locale);
            }
            if (this.isCarrierUser == true) {
              this.gridApi.setGridOption('rowData', this.documentManagementList);
            } else {
              this.docMgmtGridApi.setGridOption('rowData', this.documentManagementList);
            }
          }, error => {
            this.loader.hide();
            this.alertService.error('There was an error saving the document!');

          });
        }
      });
    } else {
      this.docObj = new DocumentManagerObj();
      this.docObj.documentType = this.documentManagementForm.get('documentType').value;
      if (this.documentManagementForm.get('effectiveDate').touched === false || this.checkNoEffDate === false) {
        this.docObj.effectiveDate = this.documentManagementForm.get('effectiveDate').value;
      } else {
        this.docObj.effectiveDate = (!this.checkNoEffDate) ? this.documentManagementForm.get('effectiveDate').value : null;
      }
      if(this.checkNoExpDate === true){
        this.docObj.expiryDate = (!this.checkNoExpDate) ? this.documentManagementForm.get('expiryDate').value : null;
      }else{
        if (this.documentManagementForm.get('expiryDate').touched == false || this.checkNoExpDate === false) {
          this.docObj.expiryDate = this.documentManagementForm.get('expiryDate').value;
        }
      }
      this.docObj.dateCreated = new Date();
      this.docObj.dateLastUploaded = new Date();
      this.docObj.updateDate = new Date();
      this.docObj.customerType = TypeOfUser.TSP;
      this.docObj.userId = this.currentUser.userId;
      this.docObj.organizationId = this.organizationId;
      // this.docObj.organizationId = 1;
      this.docObj.documentStatus = this.docObj.documentType.includes("TSP Agreement")?  DocumenetStatuses.FINALIZED :  DocumenetStatuses.PENDING_REVIEW;
      const fileNaming = this.documentManagementForm.get('filePicker').value;
      this.docObj.fileName = fileNaming.substr(fileNaming.indexOf('C:\\fakepath\\') + 12);
      this.docObj.documentName = this.docObj.fileName;
      this.docObj.additionalComments = this.documentManagementForm.get('additionalComments').value;
      // this.docObj.documentStatus = DocumenetStatuses.PENDING_REVIEW;
      this.docObj.tspSigned = 0;
      this.docObj.gsaSigned = 0;
      this.docObj.businessType = this.businessTypeCheck;
      if (this.isSysAdmin == true) {
        this.docObj.documentStatus = DocumenetStatuses.FINALIZED;
        const scacFull = this.documentManagementForm.get('scacList').value;
        this.scacCode = scacFull.substr(0, scacFull.indexOf(' '));
        if (this.scacCode == '') {
          this.scacCode = scacFull;
        }
        this.docObj.scac = this.scacCode;
        this.docObj.businessType = this.businessTypeCheck;
        for (const carrierItem of this.carrierList) {
          if (this.scacCode == carrierItem.scac) {
            this.docObj.carrierId = carrierItem.carrierId;
            break;
          }
        }
      } else if (this.isCarrierUser == true) {
        this.docObj.carrierId = this.currentUser.carrierId;
      }
      if (this.uploadFileWithDetails() != false) {
        this.loader.show();
        this.documentManagerService.saveDocument(this.docObj).subscribe({
          next: data => {
            this.alertService.success('Saved Document');
            this.loader.hide();
            this.docObj.documentManagerId = data.documentManagerId;
            this.docObj.scac = this.scacCode;
  
            this.docObj.formattedEffectiveDate = (data.effectiveDate == null) ? 'Always Effective' : formatDate(data.effectiveDate, this.format, this.locale);
            this.docObj.formattedExpiryDate = (data.expiryDate == null) ? 'No Expiration' : formatDate(data.expiryDate, this.format, this.locale);
  
  
            if (this.isSysAdmin == true)  this.docObj.documentStatus = DocumenetStatuses.FINALIZED;
            this.docObj.formattedUploadDate = formatDate(this.docObj.dateLastUploaded, this.format, this.locale);
            this.docObj.updatedBy = this.userEmail;
  
            if (this.isCarrierUser == true) {
              this.gridApi.applyTransaction({ add: [this.docObj] });
              this.documentManagementList.push(this.docObj);
            } else {
              var removedObj = this.onUpdateClientData(data.carrierId, data.documentType , data.documentManagerId);
              if(AppConstants.isNotNullCondition(removedObj)){
                this.docMgmtGridApi.applyTransaction({ remove: [removedObj] });
                var removedPosition = this.documentManagementList.findIndex((aDoc: any) => {
                  return aDoc.documentManagerId === removedObj.documentManagerId;
                });
                if(removedPosition > -1) this.documentManagementList.splice(removedPosition,1);
              }
                
              this.docMgmtGridApi.applyTransaction({ add: [this.docObj] });
              this.documentManagementList.push(this.docObj);
            }
          },
          error: () => {
            this.loader.hide();
            this.alertService.error('There was an error saving the document!');
          }
        });
      }
    }
  }

  private onUpdateClientData(carrID:any, documentType: any, documentManagementID: any){
    var changedDocumentStatus = this.documentManagementList.find((item: any) => (
                  (item.carrierId === carrID) 
                  && (item.documentType === documentType) 
                  && (item.documentStatus === DocumenetStatuses.FINALIZED) 
                  && (item.documentManagerId !== documentManagementID) 
                  && AppConstants.isNotNullCondition(item.documentManagerId)));
      return changedDocumentStatus;

  }

  private initializeGridOptions() {
    return <GridOptions>{
      columnDefs: this.getDocumentManagementCarrierColumnDefs(),
      context: {parentComponent: this},
      rowSelection: 'single',
      rowHeight: 45,
      defaultColDef: {
        sortable: true,
        resizable: true,
        filter: 'agNumberColumnFilter',
        filterParams: {
          suppressAndOrCondition: true
        }
      },
      headerHeight: 50,
      pagination: true,
      paginationPageSize: 25,
      cacheBlockSize: 25,
      domLayout: 'autoHeight',
      rowData: this.documentManagementList,
      onGridReady: params => {
        params.api.sizeColumnsToFit();
      },
      overlayLoadingTemplate:
        '<span class="ag-overlay-loading-center">Please wait while your rows are loading</span>',
      overlayNoRowsTemplate:
        '<span>No results found. Please adjust your filters.</span>'
    };
  }

  private initializeDocGridOptions() {
    return <GridOptions>{
      columnDefs: this.getDocumentManagementColumnDefs(),
      context: {parentComponent: this},
      rowSelection: 'single',
      rowHeight: 45,
      defaultColDef: {
        sortable: true,
        resizable: true,
        filter: 'agTextColumnFilter',
        filterParams: {
          suppressAndOrCondition: true
        }
      },
      headerHeight: 50,
      pagination: true,
      paginationPageSize: 25,
      // cacheBlockSize: 25,
      domLayout: 'autoHeight',
      rowData: this.documentManagementList,
      onGridReady: params => {
        this.docMgmtGridApi = params.api;
        params.api.sizeColumnsToFit();
      },
      defaultCsvExportParams: {
        fileName: 'FRT_Document_Management_View'
      },
      defaultExcelExportParams: {
        fileName: 'FRT_Document_Management_View'
      },
      overlayLoadingTemplate:
        '<span class="ag-overlay-loading-center">Please wait while your rows are loading</span>',
      overlayNoRowsTemplate:
        '<span>No results found. Please adjust your filters.</span>'
    };
  }

  getDocumentManagementColumnDefs(): (ColDef | ColGroupDef)[] {
    return [
      <ColDef>
        {
          headerName: 'SCAC',
          field: 'scac',
          filter: 'agTextColumnFilter',
          rowGroup: true,
          icons: {
            sortAscending: '<i class="fa fa-sort-alpha-up"/>',
            sortDescending: '<i class="fa fa-sort-alpha-down"/>'
          },
        },
      {
        headerName: 'Document Type',
        field: 'documentType',
        filter: 'agTextColumnFilter',
        rowGroup: true,
      },
      {
        headerName: 'File Name',
        field: 'fileName',
        filter: 'agTextColumnFilter'
      },
      {
        headerName: 'Document Status',
        field: 'documentStatus',
        filter: 'agTextColumnFilter'
      },
      {
        headerName: 'Updated By',
        field: 'updatedBy',
        filter: 'agTextColumnFilter'
      },
      {
        headerName: 'Date Of Action',
        field: 'formattedUpdateDate',
        filter: 'agTextColumnFilter'
      },
      {
        headerName: 'Effective Date',
        field: 'formattedEffectiveDate',
        filter: 'agTextColumnFilter'
      },
      {
        headerName: 'Expiry Date',
        field: 'formattedExpiryDate',
        filter: 'agTextColumnFilter'
      },
      {
        headerName: 'Date Last Uploaded',
        field: 'formattedUploadDate',
        filter: 'agTextColumnFilter'
      },
      {
        headerName: 'Additional Comments',
        field: 'additionalComments',
        filter: 'agTextColumnFilter',
        cellClass: 'cell-wrap-text',
      },
      {
        headerName: 'Document Manager ID',
        field: 'documentManagerId',
        hide: true
      },
      {
        headerName: 'Sign/Download',
        cellRendererSelector: function (params) {
        
          const buttonRendererDownload = {
            component: 'buttonRendererDownload'
          };
          if (params.data == null) {
            return null;
          } else {
            return buttonRendererDownload;
          }
        },
        cellRendererParams: {
          onClick: this.onDownloadClick.bind(this),
          label: 'Sign2'
        }
      },
      {
        headerName: 'Delete',
        cellRendererSelector: function (params) {
          const buttonRenderer = {
            component: 'buttonRenderer'
          };

          if (params.data == null) {
            return null;
          } else {
            return buttonRenderer;
          }
        },
        cellRendererParams: {
          onClick: this.onDeleteADocument.bind(this),
          label: 'Delete'
        }
      },
      {
        headerName: 'Approve',
        cellRendererSelector: function (params) {
          const buttonRendererApprove = {
            component: 'buttonRendererApprove'
          };

          if (params.data == null) {
            return null;
          } else {
            return buttonRendererApprove;
          }
        },
        cellRendererParams: {
          onClick: this.onApproveClick.bind(this),
          label: 'Approve'
        }
      },
      {
        headerName: 'Reject',
        cellRendererSelector: function (params) {
          const buttonRendererReject = {
            component: 'buttonRendererReject'
          };
          if (params.data == null) {
            return null;
          } else {
            return buttonRendererReject;
          }
        },
        cellRendererParams: {
          onClick: this.onRejectClick.bind(this),
          label: 'Reject'
        }
      },
      {
        headerName: 'Approval/Rejected Comment',
        field: 'approvalComments',
        editable: true,
        filter: 'agTextColumnFilter'
      }
    ];
  }

  getDocumentManagementCarrierColumnDefs(): (ColDef | ColGroupDef)[] {
    var tspSigned :boolean = false;
    var gsaSigned :boolean = false;
    var envelopeIdExist : boolean = false;
    var tspAgreement :boolean = false;
    return [
      <ColDef>
        {
          headerName: 'Document Type',
          field: 'documentType',
          filter: 'agTextColumnFilter',
          rowGroup: true,
          hide: true
        },
      {
        headerName: 'File Name',
        field: 'fileName',
        filter: 'agTextColumnFilter'
      },
      {
        headerName: 'Document Status',
        field: 'documentStatus',
        filter: 'agTextColumnFilter'
      },
      {
        headerName: 'Effective Date',
        field: 'formattedEffectiveDate',
        filter: 'agTextColumnFilter'
      },
      {
        headerName: 'Expiry Date',
        field: 'formattedExpiryDate',
        filter: 'agTextColumnFilter'
      },
      {
        headerName: 'Date Last Uploaded',
        field: 'formattedUploadDate',
        filter: 'agTextColumnFilter'
      },
      {
        headerName: 'Additional Comments',
        field: 'additionalComments',
        filter: 'agTextColumnFilter',
        cellClass: 'cell-wrap-text',
      },
      {
        headerName: 'Approval/Rejected Comment',
        field: 'approvalComments',
        filter: 'agTextColumnFilter'
      },
      {
        headerName: 'Sign/Download',
        cellRendererSelector: function (params) {
          const buttonRendererDownload = {
            component: 'buttonRendererDownload'
          };

          // if (params.data == null) {
          //   return null;
          // }

          // if (params.data != null && params.data.documentType != null && params.data.documentType.includes('TSP Agreement')) {
          //   tspAgreement = true;
          //   if (params.data.tspSigned != null && params.data.tspSigned > 0) {
          //     tspSigned = true;
          //   }
          //   if (params.data.gsaSigned != null && params.data.gsaSigned > 0) {
          //     gsaSigned = true;
          //   }
          //   if (tspSigned && tspSigned && params.data.docSignEnvelopeId != null) {
          //     envelopeIdExist = true;
          //   }
          // }
          // console.log("tspAgreement:"+tspAgreement +":tspSigned:"+tspSigned+":gsaSigned:"+ gsaSigned+":envelopeIdExist:"+envelopeIdExist );

          if (params.data == null) {
            return null;
          } else {
            return buttonRendererDownload;
          }
        },
        cellRendererParams: {
          onClick: this.carrierDownload.bind(this),
          label: (tspAgreement ? 'Sign':'Download'),
          sysAdmin: this.isSysAdmin
        }
      },
    ];
  }

  /**
   * sorting the data
   * @param sortModel
   * @param data
   */
  sortData(sortModel, data) {
    const sortPresent = sortModel && sortModel.length > 0;
    if (!sortPresent) {
      return data;
    }
    const resultOfSort = data.slice();
    resultOfSort.sort(function (a, b) {
      for (let k = 0; k < sortModel.length; k++) {
        const sortColModel = sortModel[k];
        const valueA = a[sortColModel.colId];
        const valueB = b[sortColModel.colId];
        if (valueA === valueB) {
          continue;
        }
        const sortDirection = sortColModel.sort === 'asc' ? 1 : -1;
        if (valueA > valueB) {
          return sortDirection;
        } else {
          return sortDirection * -1;
        }
      }
      return 0;
    });
    return resultOfSort;
  }

  /**
   * filtering the data
   * @param filterModel
   * @param data
   */
  filterData(filterModel, data) {
    const filterPresent = filterModel && Object.keys(filterModel).length > 0;
    if (!filterPresent) {
      return data;
    }
    const resultOfFilter = [];
    for (let i = 0; i < data.length; i++) {
      const item = data[i];
      if (filterModel.updateFlag) {
        if (filterModel.updateFlag.filter.toUpperCase().indexOf(item.updateFlag.toString().toUpperCase()) < 0) {
          continue;
        }
      }
      if (filterModel.destinationType) {
        if (filterModel.destinationType.filter.toUpperCase().indexOf(item.destinationType.toString().toUpperCase()) < 0) {
          continue;
        }
      }
      resultOfFilter.push(item);
    }
    return resultOfFilter;
  }

  onDeleteADocument(e: any) {
    const tempList = this.documentManagementList;
    this.docObj = new DocumentManagerObj();
    debugger;
    e.rowData.documentStatus = DocumenetStatuses.DELETED;
    this.docObj = this.buildDocumentManagerObject(e.rowData);
    this.documentManagerService.saveDocument(this.docObj).subscribe({
      next: data => {
        var findRemovedDocument = this.documentManagementList.find((aDoc:any) => aDoc.documentManagerId === this.docObj.documentManagerId )
        if(!AppConstants.isNotNullCondition(findRemovedDocument)) return;
        if (this.isCarrierUser == true) {
          this.gridApi.applyTransaction({ remove: [findRemovedDocument] });
        } else {
          this.docMgmtGridApi.applyTransaction({ remove: [findRemovedDocument] });
        }
        for (let i = 0; i < this.documentManagementList.length; i++) {
          if (e.rowData.documentManagerId == this.documentManagementList[i].documentManagerId) {
            tempList.splice(i, 1);
            break;
          }
        }
      },
      error: err => {},
      complete: () => {console.log('Completion')}
    });
   
  }

  onRejectClick(e: any) {
    this.docObj = new DocumentManagerObj();
    this.docObj = this.buildDocumentManagerObject(e.rowData);
    debugger;
    if (e.rowData.documentStatus !== DocumenetStatuses.REJECTED) {
      if (AppConstants.isNotNullCondition(this.docObj.approvalComments)) {
        if (this.docObj.approvalComments.trim() !== '') {
          this.modalRef = this.modalService.show(ConfirmationModalComponent);
          this.modalRef.content.question = 'By clicking “OK”, you acknowledge that you are about ' +
            'to delete a document. ' + this.docObj.fileName +
            'Click “Cancel” to return to the shipment booking form.';
          this.modalRef.content.confirmText = 'OK';
          this.modalRef.content.cancelText = 'Cancel';
          this.modalRef.content.emitData.subscribe(result => {
            if (result.obj === true) {

              e.rowData.documentStatus = DocumenetStatuses.REJECTED;
              this.docObj.documentStatus = DocumenetStatuses.REJECTED;
              this.docObj.currentUser = 0;
              this.documentManagerService.saveDocumentStatus(this.docObj).subscribe(data => {
                this.alertService.success('Successful');
                const rowNode = this.docMgmtGridApi.getRowNode(this.docMgmtGridApi.getSelectedNodes()[0].id);
                rowNode.setDataValue('documentStatus', e.rowData.documentStatus);
                rowNode.setDataValue('formattedUpdateDate', formatDate(new Date(), this.format, this.locale));
                rowNode.setDataValue('updatedBy', this.userEmail);

                var paramsRefresh: RefreshCellsParams = {
                  force: true,
                  suppressFlash: true,
                  rowNodes: [rowNode],
                };
                this.docMgmtGridApi.redrawRows();
              });

            }
          });
        } else {
          this.alertService.error('Please give a reason to reject this document');
        }
      } else {
        this.alertService.error('Please give a reason to reject this document');
      }
    }
  }

  onBtnFinalizedDocument(e: any) {
    let finalizedObj = new DocumentManagerObj();
    finalizedObj = this.buildDocumentManagerObject(e.rowData);
    debugger;
    const tempList = this.documentManagementList;
    if (e.rowData.documentStatus !== DocumenetStatuses.REJECTED) {
      this.modalRef = this.modalService.show(ConfirmationModalComponent);
      this.modalRef.content.question = 'By clicking “OK”, you acknowledge that you are about to make the document. ' + finalizedObj.fileName
        + 'to be the current version Click “Cancel” to return to the shipment booking form.';
      this.modalRef.content.confirmText = 'OK';
      this.modalRef.content.cancelText = 'Cancel';
      this.modalRef.content.emitData.subscribe(result => {
        if (result.obj === true) {
          var findAFinalizedDocument = tempList.find(obj => {
            return obj.carrierId === finalizedObj.carrierId && obj.documentType === finalizedObj.documentType;
          });

          var updatedDocument = [];
          finalizedObj.documentStatus = DocumenetStatuses.FINALIZED;
          updatedDocument.push(finalizedObj);
          if (AppConstants.isNotNullCondition(findAFinalizedDocument)) {
            updatedDocument.push(findAFinalizedDocument);
          }
          this.documentManagerService.finalizedDocumentStatus(updatedDocument).subscribe(data => {
            this.alertService.success('Successful');
            this.loadDocumentListForSystemAdmin(BusinessType.FRT);
          });
        }
      });
    }
  }

  onApproveClick(e: any) {
    this.docObj = new DocumentManagerObj();
    this.docObj = this.buildDocumentManagerObject(e.rowData);
    
    if (e.rowData.documentStatus !== DocumenetStatuses.FINALIZED) {
      this.modalRef = this.modalService.show(ConfirmationModalComponent);
      this.modalRef.content.body = 'Are you going to approve the document '+ this.docObj.fileName + ' ?';
      this.modalRef.content.title = 'Confirm Approve';
      this.modalRef.content.confirmText = 'Approve';
      this.modalRef.content.cancelText = 'Cancel';
      this.modalRef.content.emitData.subscribe((res: any) => {
        if(res.actions === "confirm" && res.obj === true){
          e.rowData.documentStatus = DocumenetStatuses.FINALIZED;
        this.docObj.documentStatus = DocumenetStatuses.FINALIZED;
        this.documentManagerService.saveDocumentStatus(this.docObj).subscribe({
          next: data => {
            this.alertService.success('Approved');
            const rowNode = this.docMgmtGridApi.getRowNode(this.docMgmtGridApi.getSelectedNodes()[0].id);
            rowNode.data.documentStatus = DocumenetStatuses.FINALIZED;
            rowNode.data.formattedUpdateDate = formatDate(new Date(), this.format, this.locale);
            rowNode.data.updatedBy = this.userEmail;
            var removedObj =  this.onUpdateClientData(data.carrierId, data.documentType , data.documentManagerId);
            if(AppConstants.isNotNullCondition(removedObj)){
              this.docMgmtGridApi.applyTransaction({ remove: [removedObj] });
             
              var removedPosition = this.documentManagementList.findIndex((aDoc: any) => {
                return aDoc.documentManagerId === e.rowData.documentManagerId;
              });
  
              if(removedPosition > -1) this.documentManagementList.splice(removedPosition,1);
            }
            this.docMgmtGridApi.redrawRows();
          },
          error: err => { console.log(err);}
        });
        }
      });
    }
  }

  onDownloadClick(e: any) {
    this.docObj = e.rowData;
    this.downloadService.downloadDocForSysAdmin('Documents', this.docObj.fileName, this.docObj.scac).subscribe({
      next: response => {fileSaver.saveAs(response, this.docObj.fileName);},
      error: err => {console.log(err)}
    });
  }


  carrierDownload(e: any) {
    this.docObj = e.rowData;
    this.downloadService.downloadFile('Documents', this.docObj.fileName, null).subscribe({
      next: response => {fileSaver.saveAs(response, this.docObj.fileName);},
      error: err => {console.log(err)}
    });

  }

  carrierGSATSPAgreementSign(e: any) {
    this.docObj = e.rowData;
    this.downloadService.downloadFile('Documents', this.docObj.fileName, null).subscribe({
      next: response => {fileSaver.saveAs(response, this.docObj.fileName);},
      error: err => {console.log(err)}
    });

  }

  carrierTSPAgreementSign(e: any) {
    this.docObj = e.rowData;
    this.downloadService.downloadFile('Documents', this.docObj.fileName, null).subscribe({
      next: response => {fileSaver.saveAs(response, this.docObj.fileName);},
      error: err => {console.log(err)}
    });

  }

  isForceRefreshSelected() {
    return document.querySelector('#forceRefresh');
  }

  onCheckNoEffDate(value: boolean) {
    this.checkNoEffDate = !this.checkNoEffDate;
    this.checkNoEffDate ? (this.documentManagementForm.controls['effectiveDate'].disable()) : this.documentManagementForm.controls['effectiveDate'].enable();
  }

  onDocumentType(e: any) {
    this.docTypeSelected = false;
    this.tspOrOtherDocType = false;
    const docTypeSelection: String = this.documentManagementForm.get("documentType").value;
    docTypeSelection ? (this.docTypeSelected=true) : (this.docTypeSelected=false);
    if (docTypeSelection && (docTypeSelection === this.documentTypeList[2] 
      || docTypeSelection === this.documentTypeList[4])) {
      this.tspOrOtherDocType = true;
      this.checkNoExpDate = true;
      this.disabledExpiryDate = true;
      this.documentManagementForm.controls['expiryDate'].disable();
    }else{
      this.disabledExpiryDate = false;
      this.documentManagementForm.controls['expiryDate'].enable();
    }
    
  }

  onCheckNoExpDate(value: boolean) {
    this.checkNoExpDate = !this.checkNoExpDate;
    if (this.checkNoExpDate) {
      this.documentManagementForm.controls['expiryDate'].disable();
    } else {
      this.documentManagementForm.controls['expiryDate'].enable();
    }
  }

  gotoReport() {
    this.router.navigate(['/documentmanagementreport'],
      {
        queryParams: {
          businessType: [this.businessTypeCheck]
        }
      });
  }

  goToFRTtempNonUseDocMgmtReport() {
    this.router.navigate(['/frtTempNonUseTSPsDocMgmtReport'],
      {
        queryParams: {
          businessType: [this.businessTypeCheck]
        }
      });
  }


  buildDocumentManagerObject(obj: any){
    return {
        documentManagerId: obj.documentManagerId,
        documentType: obj.documentType,
        documentName: obj.documentName,
        dateCreated: obj.dateCreated,
        dateLastUploaded: obj.dateLastUploaded,
        effectiveDate: obj.effectiveDate,
        expiryDate: obj.expiryDate,
        customerType: obj.customerType,
        userID:obj.userID,
        fileName: obj.fileName,
        carrierId: obj.carrierId,
        adminOnlyFlag: obj.adminOnlyFlag,
        additionalComments: obj.additionalComments,
        organizationId: obj.organizationId,
        documentStatus: obj.documentStatus,
        scac: obj.scac,
        businessType: obj.businessType,
        updateId: obj.updateId,
        updateProgram: obj.updateProgram,
        updatedBy: obj.updatedBy,
        approvalComments: obj.approvalComments,
        updateDate: obj.updateDate,
        currentVersion: 0,
        gsaSigned: obj.gsaSigned,
        tspSigned: obj.tspSigned
    };
  }
}

//this can be removed if we do not use 
// editDoc() {
//   this.editMode = false;
//   this.docObj = this.documentManagementList[this.docIndex];
//   this.docObj.documentType = this.documentManagementEditForm.get('documentType').value;
//   this.docObj.documentName = this.documentManagementEditForm.get('documentName').value;
//   this.docObj.effectiveDate = this.documentManagementEditForm.get('effectiveDate').value;
//   this.docObj.expiryDate = this.documentManagementEditForm.get('expiryDate').value;
//   this.docObj.customerType = 'Agency';
//   this.docObj.userId = this.currentUser.userId;
//   this.docObj.organizationId = this.organizationId;
//   //this.docObj.organizationId = 1;
//   this.docObj.fileName = 'test.pdf';
//   this.docObj.additionalComments = this.documentManagementEditForm.get('additionalComments').value;
//   if (this.isSysAdmin == true) {
//     const toggleFlag = this.documentManagementEditForm.get('sysAdminToggle').value;
//     if (toggleFlag) {
//       this.docObj.adminOnlyFlag = 1;
//     } else {
//       this.docObj.adminOnlyFlag = 0;
//     }
//     const scacCode = this.documentManagementEditForm.get('scacList').value;
//     for (const carrierItem of this.carrierList) {
//       if (scacCode == carrierItem.scac) {
//         this.docObj.carrierId = carrierItem.carrierId;
//         break;
//       }
//     }
//   } else if (this.isCarrierUser == true) {
//     this.docObj.carrierId = this.currentUser.carrierId;
//   }
//   this.documentManagementList[this.docIndex] = this.docObj;
//   this.documentManagerService.saveDocument(this.docObj).subscribe(data => {
//     this.uploadFile();
//     this.gridApi.setGridOption('rowData', this.documentManagementList);
//     this.editMode = false;
//   });
// }
